export const camo = [
  {
    number: 'C100',
    hasModel: false,
  },
  {
    number: 'C101',
    hasModel: false,
  },
  {
    number: 'C102',
    hasModel: false,
  },
  {
    number: 'C103',
    hasModel: false,
  },
  {
    number: 'C104',
    hasModel: false,
  },
  {
    number: 'C105',
    hasModel: false,
  },
  {
    number: 'C106',
    hasModel: false,
  },
  {
    number: 'C107',
    hasModel: false,
  },
  {
    number: 'C108',
    hasModel: false,
  },
  {
    number: 'C109',
    hasModel: false,
  },
  {
    number: 'C110',
    hasModel: false,
  },
  {
    number: 'C111',
    hasModel: false,
  },
  {
    number: 'C112',
    hasModel: false,
  },
  {
    number: 'C113',
    hasModel: false,
  },
  {
    number: 'C114',
    hasModel: false,
  },
  {
    number: 'C115',
    hasModel: false,
  },
  {
    number: 'C116',
    hasModel: false,
  },
  {
    number: 'C117',
    hasModel: false,
  },
  {
    number: 'C118',
    hasModel: false,
  },
  {
    number: 'C119',
    hasModel: false,
  },
  {
    number: 'C120',
    hasModel: false,
  },
  {
    number: 'C121',

    hasModel: false,
  },
  {
    number: 'C122',
    hasModel: false,
  },
  {
    number: 'C123',
    hasModel: false,
  },
  {
    number: 'C124',
    hasModel: false,
  },
  {
    number: 'C125',
    hasModel: false,
  },
  {
    number: 'C126',
    hasModel: false,
  },
  {
    number: 'C127',
    hasModel: false,
  },
  {
    number: 'C128',
    hasModel: false,
  },
  {
    number: 'C129',
    hasModel: false,
  },
];